export const REQUEST_ADDVIDEOTRIM = 'REQUEST_ADDVIDEOTRIM';
export const ADDVIDEOTRIM_RECEIVED = 'ADDVIDEOTRIM_RECEIVED';
export const CLEAR_VIDEOTRIM = 'CLEAR_VIDEOTRIM';